import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import BolillaDetailedVotesModal from './BolillaDetailedVotesModal';
import LogInModal from 'flarum/forum/components/LogInModal';
const dayjs = window.dayjs;
export default class BolillaWidget extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.match = this.attrs.match;
    this.submitting = false;

    // Find existing vote for current user
    this.existingVote = null;
    if (app.session.user && this.match.bolillaVotes()) {
      const userId = app.session.user.id();
      this.existingVote = this.match.bolillaVotes().find(v => v.user() && v.user().id() === userId);
    }
    this.votedScore = this.existingVote ? this.existingVote.votedScore() : null;
    this.votedKnockoutWinner = this.existingVote ? this.existingVote.votedKnockoutWinner() : null;
  }
  view() {
    const matchDate = this.match.matchDate();
    const deadline = matchDate ? dayjs(matchDate).subtract(2, 'hours') : null;
    const votingClosed = deadline && dayjs().isAfter(deadline);
    const scoresList = ['0-0', '1-0', '0-1', '1-1', '2-0', '0-2', '2-1', '1-2', '2-2', '3-0', '0-3', '3-1', '1-3', '3-2', '2-3', '3-3'];
    const otherScores = ['Gana Athletic (otro resultado)', 'Empate (otro resultado)', 'Gana Rival (otro resultado)'];
    const showPercentages = this.existingVote !== null || votingClosed;
    const totalVotes = this.match.bolillaVotes() ? this.match.bolillaVotes().length : 0;
    const getScorePercentage = score => {
      const votes = this.match.bolillaVotes();
      if (!votes || votes.length === 0) return 0;
      const count = votes.filter(v => v.votedScore() === score).length;
      return Math.round(count / votes.length * 100);
    };
    const getKnockoutPercentage = winner => {
      const votes = this.match.bolillaVotes();
      if (!votes || votes.length === 0) return 0;
      const count = votes.filter(v => v.votedKnockoutWinner() === winner).length;
      return Math.round(count / votes.length * 100);
    };
    if (this.match.isSuspended()) {
      return m("div", {
        className: "BolillaWidget BolillaWidget--suspended",
        style: "border: 1px solid rgba(245, 158, 11, 0.3); background: rgba(245, 158, 11, 0.05); border-radius: 12px; padding: 24px; text-align: center; margin-bottom: 20px;"
      }, m("div", {
        style: "font-size: 2.2rem; color: #f59e0b; margin-bottom: 10px;"
      }, m("i", {
        className: "fas fa-ban"
      })), m("h3", {
        style: "margin: 0 0 8px 0; color: #f59e0b; font-size: 1.25em; font-weight: 700;"
      }, "La Bolilla: Partido Suspendido"), m("p", {
        style: "margin: 0 auto; color: var(--muted-color); font-size: 0.95em; max-width: 500px; line-height: 1.5;"
      }, "Al no disputarse el partido completo o haberse suspendido, la porra ha quedado cancelada sin asignaci\xF3n de puntos."));
    }
    return m("div", {
      className: "BolillaWidget"
    }, m("div", {
      className: "BolillaWidget-Header"
    }, m("h3", null, m("i", {
      className: "fas fa-futbol"
    }), " La Bolilla: ", this.match.getName())), m("div", {
      className: "BolillaWidget-deadline ".concat(votingClosed ? 'closed' : '')
    }, votingClosed ? m("span", {
      className: "closed"
    }, m("i", {
      className: "fas fa-lock"
    }), " Votaci\xF3n cerrada") : deadline && m("span", null, m("i", {
      className: "far fa-clock"
    }), " Cierra ", dayjs(deadline).fromNow())), !app.session.user ? m("div", {
      className: "BolillaWidget-GuestMessageWrapper",
      style: "text-align: center; padding: 25px 15px;"
    }, m("p", {
      className: "BolillaWidget-GuestMessage",
      style: "margin-bottom: 15px; font-weight: 500;"
    }, "Inicia sesi\xF3n para participar en La Bolilla."), m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, m("i", {
      className: "fas fa-sign-in-alt",
      style: "margin-right: 6px;"
    }), "Acceder al foro")) : m("div", {
      className: "BolillaWidget-Body"
    }, m("div", {
      className: "BolillaWidget-Scores"
    }, m("p", null, m("strong", null, "Elige el resultado:")), m("div", {
      className: "BolillaWidget-Grid"
    }, scoresList.map(score => {
      const percentage = getScorePercentage(score);
      return m("button", {
        className: "Button BolillaButton ".concat(this.votedScore === score ? 'active' : '', " ").concat(showPercentages ? 'has-percentage' : ''),
        disabled: votingClosed,
        onclick: () => this.votedScore = score,
        style: showPercentages ? "background: linear-gradient(to right, var(--bolilla-pct-fill, rgba(139, 0, 0, 0.15)) ".concat(percentage, "%, transparent ").concat(percentage, "%); position: relative;") : ''
      }, m("span", {
        className: "BolillaButton-Label"
      }, score), showPercentages && m("span", {
        className: "BolillaButton-PctText"
      }, percentage, "%"));
    })), m("div", {
      className: "BolillaWidget-Others"
    }, otherScores.map(score => {
      const percentage = getScorePercentage(score);
      return m("button", {
        className: "Button BolillaButton BolillaButton--wide ".concat(this.votedScore === score ? 'active' : '', " ").concat(showPercentages ? 'has-percentage' : ''),
        disabled: votingClosed,
        onclick: () => this.votedScore = score,
        style: showPercentages ? "background: linear-gradient(to right, var(--bolilla-pct-fill, rgba(139, 0, 0, 0.15)) ".concat(percentage, "%, transparent ").concat(percentage, "%); position: relative;") : ''
      }, m("span", {
        className: "BolillaButton-Label"
      }, score), showPercentages && m("span", {
        className: "BolillaButton-PctText"
      }, percentage, "%"));
    }))), this.match.isKnockout() && m("div", {
      className: "BolillaWidget-Knockout ".concat(this.votedScore && !this.votedKnockoutWinner ? 'is-pending' : '')
    }, m("p", null, m("strong", null, "\xBFQui\xE9n pasa la eliminatoria?"), m("span", {
      className: "BolillaWidget-RequiredBadge"
    }, "* Obligatorio")), m("div", {
      className: "BolillaWidget-Grid"
    }, ['Athletic', 'Rival'].map(winner => {
      const percentage = getKnockoutPercentage(winner);
      return m("button", {
        className: "Button BolillaButton ".concat(this.votedKnockoutWinner === winner ? 'active' : '', " ").concat(showPercentages ? 'has-percentage' : ''),
        disabled: votingClosed,
        onclick: () => this.votedKnockoutWinner = winner,
        style: showPercentages ? "background: linear-gradient(to right, var(--bolilla-pct-fill, rgba(139, 0, 0, 0.15)) ".concat(percentage, "%, transparent ").concat(percentage, "%); position: relative;") : ''
      }, m("span", {
        className: "BolillaButton-Label"
      }, winner === 'Athletic' ? 'Athletic' : this.match.rival() ? this.match.rival().name() : this.match.opponent()), showPercentages && m("span", {
        className: "BolillaButton-PctText"
      }, percentage, "%"));
    }))), !votingClosed && m("div", {
      className: "BolillaWidget-Actions"
    }, this.votedScore && this.match.isKnockout() && !this.votedKnockoutWinner && m("div", {
      className: "BolillaWidget-PendingNotice"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), m("span", null, "Selecciona tambi\xE9n ", m("strong", null, "qui\xE9n pasa la eliminatoria"), " para poder guardar tu voto.")), !this.votedScore && this.match.isKnockout() && this.votedKnockoutWinner && m("div", {
      className: "BolillaWidget-PendingNotice"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), m("span", null, "Elige tambi\xE9n el ", m("strong", null, "resultado"), " para poder guardar tu voto.")), m("div", null, m(Button, {
      className: "Button Button--primary",
      loading: this.submitting,
      disabled: !this.votedScore || this.match.isKnockout() && !this.votedKnockoutWinner,
      onclick: this.submitVote.bind(this)
    }, this.existingVote ? 'Cambiar voto' : 'Votar'))), this.existingVote && votingClosed && m("div", {
      className: "BolillaWidget-Result"
    }, m("p", null, "Tu voto: ", m("strong", null, this.existingVote.votedScore()), " ", this.match.isKnockout() ? "(Pasa: ".concat(this.existingVote.votedKnockoutWinner(), ")") : ''), this.match.scoreAthletic() !== null && m("p", null, "Resultado real: ", m("strong", null, this.match.getScore()), ". Puntos: ", m("strong", null, this.existingVote.points())))), m("div", {
      className: "BolillaWidget-Footer"
    }, m(Button, {
      className: "Button Button--link BolillaWidget-DetailBtn",
      onclick: () => app.modal.show(BolillaDetailedVotesModal, {
        match: this.match
      })
    }, m("i", {
      className: "fas fa-list-ul"
    }), " Ver detalle de votos (", totalVotes, ")")));
  }
  submitVote() {
    this.submitting = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/bolilla-votes',
      body: {
        data: {
          attributes: {
            matchId: this.match.id(),
            votedScore: this.votedScore,
            votedKnockoutWinner: this.votedKnockoutWinner
          }
        }
      }
    }).then(response => {
      const vote = app.store.pushPayload(response);
      this.existingVote = vote;

      // 1. Update underlying JSON:API relationships linkage
      if (!this.match.data.relationships) {
        this.match.data.relationships = {};
      }
      if (!this.match.data.relationships.bolillaVotes) {
        this.match.data.relationships.bolillaVotes = {
          data: []
        };
      }
      if (!Array.isArray(this.match.data.relationships.bolillaVotes.data)) {
        this.match.data.relationships.bolillaVotes.data = [];
      }
      const existsInLinkage = this.match.data.relationships.bolillaVotes.data.some(link => String(link.id) === String(vote.id()));
      if (!existsInLinkage) {
        this.match.data.relationships.bolillaVotes.data.push({
          type: 'nagusi_bolilla_votes',
          id: vote.id()
        });
      }

      // 2. Update resolved related cache inside Flarum Model
      if (this.match.related && this.match.related.bolillaVotes) {
        const index = this.match.related.bolillaVotes.findIndex(v => v.id() === vote.id());
        if (index !== -1) {
          this.match.related.bolillaVotes[index] = vote;
        } else {
          this.match.related.bolillaVotes.push(vote);
        }
      }
      app.alerts.show({
        type: 'success'
      }, '¡Voto guardado!');
      this.submitting = false;
      m.redraw();
    }).catch(() => {
      this.submitting = false;
      m.redraw();
    });
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/bolilla/BolillaWidget', BolillaWidget);